import React from 'react';

// Сиреневый бейдж-квадрат с датой (число + месяц) — такой же, как ведущий бейдж
// .cc-date у карточек уроков. Стили — класс .test-date (в Student.css, общий для
// админа и студента). draft → облако; нет даты → запасная иконка (fallback).
const MON = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

const IcoCloud = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);

export default function DateBadge({ date, draft = false, fallback = null }) {
  if (draft) {
    return <span className="test-date draft" title="Черновик — не опубликовано"><IcoCloud /></span>;
  }
  const d = date ? new Date(date) : null;
  if (!d || isNaN(d)) {
    return <span className="test-date empty">{fallback}</span>;
  }
  return (
    <span className="test-date">
      <b>{d.getDate()}</b>
      <i>{MON[d.getMonth()]}</i>
    </span>
  );
}
